export const CATEGORIES = [
  { key: 'getting_started', label: 'Getting started' },
  { key: 'buildings_access', label: 'Buildings and access' },
  { key: 'documents', label: 'Documents' },
  { key: 'integrations', label: 'Integrations' },
  { key: 'tasks', label: 'Tasks' },
  { key: 'remedials', label: 'Remedials' },
  { key: 'compliance', label: 'Compliance' },
  { key: 'reports', label: 'Reports' },
]

const normalise = value => String(value || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim()

export const searchWorkflows = (workflows, query) => {
  const q = normalise(query)
  if (!q) return workflows
  const words = q.split(' ')
  return workflows
    .map((workflow, index) => {
      const title = normalise(workflow.title)
      const keywords = (workflow.keywords || []).map(normalise)
      const haystack = [title, normalise(workflow.summary), ...keywords].join(' ')
      if (!words.every(word => haystack.includes(word))) return null
      const score = (title.includes(q) ? 4 : 0) + (keywords.some(k => k.includes(q)) ? 2 : 0) + (words.every(word => title.includes(word)) ? 1 : 0)
      return { workflow, score, index }
    })
    .filter(Boolean)
    .sort((a, b) => b.score - a.score || a.index - b.index)
    .map(entry => entry.workflow)
}

export const groupByCategory = workflows => CATEGORIES
  .map(category => ({ ...category, workflows: workflows.filter(workflow => workflow.category === category.key) }))
  .filter(group => group.workflows.length > 0)
